module.exports = __webpack_public_path__ + "img/mitanga-ed3.06f3b930.png";